import React from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import userPic from "../assets/images/user.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import defaultProfile from "../assets/images/default-profile.png";
const PersonalProfile = () => {

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>

        <Form className='fs-12'>
          <div className='AccountInnerMain d-flex align-items-center justify-content-between'>
            <h6>
              <img src={userPic} width={20} alt="user" />
              <span className='ps-1'> Personal Profile</span>
            </h6>
            <div className='uploadPic'>
              <div className='photo text-center'>
                <label htmlFor="file-upload" className='image_profile bg_dark_blue custom-file-upload'>
                  <img src={defaultProfile} alt="Profile Preview" />
                </label>
                <input id="file-upload" type="file" />
                <p className='mb-0 fs-10'>Upload Photo</p>
              </div>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" name="name" className='border-2 fs-14' required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control type="text" name="mobile_number" className='border-2 fs-14' required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Id</Form.Label>
            <Form.Control type="email" name="email" className='border-2 fs-14' />
          </Form.Group>

          <Form.Group className="mb-3 datePicker">
            <Form.Label className='d-block'>Date Of Birth</Form.Label>
            <DatePicker
              dateFormat="dd MMM, yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              className="form-control border-2 w-100 fs-14"
              placeholderText="Select Date of Birth"
              isClearable
            />
          </Form.Group>

          <Form.Group className='d-flex justify-content-between'>
            <Button variant="danger" size='sm' type="submit" className='px-3 rounded-5 text-white'>
              Submit
            </Button>
          </Form.Group>
        </Form>
      </Container>
    </div>
  );
};

export default PersonalProfile;
